import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// import { logoutUser } from "../../Redux/authAction";
import { TbLogout } from "react-icons/tb";
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../../Redux/authAction';
import { loginUser, language, loginModal } from "../../../Redux/authAction";
import { useSelector } from 'react-redux';
const LogoutComponent = (props) => {
  const [fullname, setFullname] = useState(''); // Store full name
  const [userId, setUserId] = useState(''); // Store user ID
  const isLang = useSelector((state) => state.authReducer.lang);
  const developername = useSelector((state) => state.authReducer.developername);
  const developeruid = useSelector((state) => state.authReducer.developeruid);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Retrieve and display user data from localStorage
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData')); // Use 'userData' as key based on your login code
    if (storedData && storedData.fullname && storedData.id) {
      setFullname(storedData.fullname); // Set the full name from stored data
      setUserId(storedData.id); // Set the user ID from stored data
    }
  }, []);

  const handleLogout = () => {
    // Clear local storage and reset state
    localStorage.removeItem('userData'); // Use the correct key 'userData' to clear the stored information
    dispatch(logoutUser());
    setFullname(''); // Clear the full name
    setUserId(''); // Clear the user ID
    navigate('/'); // Redirect to home page after logout
  };

  return (
    <div className='TopHeaderContainer' style={{ display: 'flex', alignItems: 'center' }}>
      {/* Always display fullname and userId */}
      <span style={{ marginRight: '10px' }}>Hello,  Name: {developername} -- ID: {developeruid}</span>
      <div className='flex gap-10'>
      <div className="cursor-pointer" onClick={() => dispatch(language(isLang === "arabic" ? "eng" : "arabic"))}>
            <p className="font-[600] text-[16px] text-[#656565]">{isLang === "arabic" ? "English" : "العربية"}</p>
          </div>
      <TbLogout onClick={handleLogout} style={{ fontSize: "30px", cursor: "pointer" }} />
      </div>
    </div>
  );
};

export default LogoutComponent;
